(function () {
  const slides = document.querySelectorAll('.cs-slide');
  const dots = document.querySelectorAll('.cs-slideshow__dot');
  const metaCurr = document.querySelector('.cs-slideshow__meta span:first-child');
  let idx = 0, timer;

  function goTo(i) {
    slides[idx].classList.remove('is-active');
    dots[idx].classList.remove('is-active');
    idx = i;
    slides[idx].classList.add('is-active');
    dots[idx].classList.add('is-active');
    if (metaCurr) metaCurr.textContent = String(idx + 1).padStart(2, '0');
  }

  function next() { goTo((idx + 1) % slides.length); }

  function start() { timer = setInterval(next, 7000); }
  function stop()  { clearInterval(timer); }

  dots.forEach((dot, i) => dot.addEventListener('click', () => { stop(); goTo(i); start(); }));

  if (slides.length > 1) start();
})();